import {Injectable} from '@angular/core';
import * as LogRocket from 'logrocket';
import {environment} from '@env/environment';
import {buildLogRocketPrivacyOptions} from './logrocket';

export interface LogRocketSettings {
    appId: string;
}

/** Starts LogRocket for every partner when the environment file defines a LogRocket appId. */
@Injectable({providedIn: 'root'})
export class LogRocketService {
    private initialized = false;
    private identifiedApplicationId = '';

    init(): void {
        // Optional: environments that don't define a `logRocket` block (e.g. prod) never record.
        const settings = (environment as {logRocket?: LogRocketSettings}).logRocket;
        if (this.initialized || !settings?.appId) {
            return;
        }
        this.initialized = true;

        try {
            // PII masking, URL/network sanitizing, console off and no IP capture (see ./logrocket).
            LogRocket.init(settings.appId, buildLogRocketPrivacyOptions());
            // IDs only, never traits: LogRocket keeps every ID identified in a session searchable.
            LogRocket.identify(String(environment.institutionId));
        } catch (error) {
            // Recording is best-effort; never let it affect the application flow.
            console.error('Failed to initialize LogRocket:', error);
        }
    }

    identifyApplication(applicationId: number | string): void {
        if (!this.initialized || !applicationId || String(applicationId) === this.identifiedApplicationId) {
            return;
        }
        this.identifiedApplicationId = String(applicationId);
        try {
            LogRocket.identify(this.identifiedApplicationId);
        } catch (error) {
            console.error('Failed to identify LogRocket session:', error);
        }
    }
}
